module.exports = {
  address: "0xec14E1a294C3378Ed4Bc2501572C4D6D636404De",
  address_test: '',
  abi: require('./Claim4.json')
}
